/**
 * Chat Loading Indicator - Shown while generating images
 */

import { useTranslation } from 'react-i18next';
import { Loading } from '@/components/v2/ui';

export function ChatLoadingIndicator() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3 px-4 py-3 ml-10">
      <Loading size="sm" variant="primary" />
      <span className="text-sm text-neutral-500 dark:text-neutral-400">
        {t('chatImage.generating')}
      </span>
    </div>
  );
}
